import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFlip = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1025 1025",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 .47h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M476 74.322c0-19.868 16.2-36 36-36 19.9 0 36 16.132 36 36v36.232c0 19.868-16.1 36-36 36-19.8 0-36-16.132-36-36zm0 181.155c0-19.868 16.2-36 36-36 19.9 0 36 16.132 36 36v72.463c0 19.869-16.1 36-36 36-19.8 0-36-16.131-36-36zm0 217.387c0-19.87 16.2-36 36-36 19.9 0 36 16.13 36 36v72.462c0 19.87-16.1 36-36 36-19.8 0-36-16.13-36-36zm0 217.386c0-19.868 16.2-36 36-36 19.9 0 36 16.132 36 36v72.462c0 19.87-16.1 36-36 36-19.8 0-36-16.13-36-36zm0 217.385c0-19.869 16.2-36 36-36 19.9 0 36 16.131 36 36v36.231c0 19.869-16.1 35.997-36 35.997-19.8 0-36-16.128-36-35.997z" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "M640 216.71v578.26h300z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeWidth: 72,
			d: "M384 216.71v578.26H84z"
		})
	]
});
export default SvgIconFlip;
